/**
 * Utilities for working JavaScript/TypeScript module files.
 *
 * @module @sorrell/utilities/fs/module
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export * as Extension from "./Extension.ts";
export * from "./Module.ts";
